module.exports = __webpack_public_path__ + "static/media/img_car_2_desktop.fae46ec9.webp";